export const IDS = {
  content: "content",
  toggle: "toggle",
  header: "header",
};

export const CSS = {
  button: "button",
  container: "container",
  content: "content",
  controlContainer: "control-container",
  description: "description",
  header: "header",
  headerContainer: "header-container",
  heading: "heading",
  icon: "icon",
  invalid: "invalid",
  statusIcon: "status-icon",
  summary: "summary",
  title: "title",
  toggle: "toggle",
  toggleIcon: "toggle-icon",
  valid: "valid",
};

export const SLOTS = {
  icon: "icon",
  control: "control",
  headerMenuActions: "header-menu-actions",
};

export const ICONS = {
  opened: "chevron-up",
  closed: "chevron-down",
  valid: "check-circle",
  invalid: "exclamation-mark-triangle",
};
